export function createPWABadgeState() {
  return {
    supported: false,
    lastAppliedCount: null
  };
}

export function derivePWABadgeCount(snapshot = {}) {
  const pendingDecisionCount = Array.isArray(snapshot?.pendingDecisions) ? snapshot.pendingDecisions.length : 0;
  if (pendingDecisionCount > 0) {
    return pendingDecisionCount;
  }
  const turns = Array.isArray(snapshot?.turns) ? snapshot.turns : [];
  return turns.filter((item) => String(item?.state || "").trim() === "running").length;
}

export async function syncPWABadge(state, snapshot = {}, options = {}) {
  if (!state) {
    return 0;
  }

  const nav = options.navigator || globalThis.navigator;
  const setBadge = typeof nav?.setAppBadge === "function" ? nav.setAppBadge.bind(nav) : null;
  const clearBadge = typeof nav?.clearAppBadge === "function" ? nav.clearAppBadge.bind(nav) : null;
  const nextCount = derivePWABadgeCount(snapshot);

  if (!setBadge && !clearBadge) {
    state.supported = false;
    state.lastAppliedCount = null;
    return nextCount;
  }

  state.supported = true;
  if (state.lastAppliedCount === nextCount) {
    return nextCount;
  }
  state.lastAppliedCount = nextCount;

  try {
    if (nextCount > 0 && setBadge) {
      await setBadge(nextCount);
    } else if (nextCount === 0 && clearBadge) {
      await clearBadge();
    }
  } catch (_error) {
    return nextCount;
  }
  return nextCount;
}
